import React from 'react';
import { useTranslation } from 'react-i18next';
import { toEuropeanDate } from 'utils/helper';
import { VisitWish } from './visitWishApi';
import { filterOf, flexibleInTime } from './wishFilters';
import './styles.scss';

export const STATUS_LABELS: Record<VisitWish['status'], string> = {
  pending_confirmation: 'Waiting for confirmation',
  active: 'Active',
  paused: 'Paused',
  fulfilled: 'Booked',
  withdrawn: 'Withdrawn by guest',
  stopped: 'Stopped by team',
  expired: 'Period over',
};

/** A running offer outranks the wish's own status: a table is held right now. */
export type WishTone = VisitWish['status'] | 'offer';

export const wishTone = (wish: VisitWish): WishTone => (filterOf(wish) === 'offer' ? 'offer' : wish.status);

const TONE_LABELS: Record<WishTone, string> = { ...STATUS_LABELS, offer: 'Offer running' };

export const period = (wish: VisitWish) =>
  wish.dateFrom === wish.dateTo
    ? toEuropeanDate(wish.dateFrom)
    : `${toEuropeanDate(wish.dateFrom)} – ${toEuropeanDate(wish.dateTo)}`;

export const timeWindow = (wish: VisitWish, t: (key: string) => string) =>
  flexibleInTime(wish) ? t('Flexible in time') : `${wish.timeFrom ?? ''}–${wish.timeTo ?? ''}`;

/** The wish's state in words; the dot repeats it in colour but never carries it alone. */
const WishStatus: React.FC<{ wish: VisitWish }> = ({ wish }) => {
  const { t } = useTranslation('reservations');
  const tone = wishTone(wish);
  return (
    <span className={`visit-wish-status visit-wish-status--${tone}`} data-status={tone}>
      <span className="visit-wish-status-dot" aria-hidden="true" />
      {t(TONE_LABELS[tone])}
    </span>
  );
};

export default WishStatus;
